import React from 'react'

import Figure from '../components/Figure'

const hubIcon = require('../../assets/img/hub-sm.png')
const controllerIcon = require('../../assets/img/agrowtek-sm.png')

const Requirements = () => (
  <section className="bg-green" id="requirements">
    <div className="container columns">
      <h2 className="column text-gray">what you&rsquo;ll need to get started</h2>
      <Figure
        figClass="column"
        imgId="hub"
        imgAlt="Farmhand Hub Illustration"
        imgSrc={hubIcon}
        capClass="text-white"
        capContent="Farmhand Hub"
      />
      <Figure
        figClass="column"
        imgId="hub"
        imgAlt="Controller Illustration"
        imgSrc={controllerIcon}
        capClass="text-white"
        capContent="Automation Controller"
      />
    </div>
  </section>
)

export default Requirements



// WEBPACK FOOTER //
// ./containers/Requirements.js